import React, { useEffect, useState } from 'react';
import { listCourses } from '../../Services/courseService';
import CourseTemplate from './CourseTemplate';
import ClipLoader from 'react-spinners/ClipLoader';
import { useTranslation } from 'react-i18next';

const ProjectCourse = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const response = await listCourses();
        const allCourses = Array.isArray(response?.data?.data) ? response?.data?.data : [];
        const filteredCourses = allCourses.filter(course =>
          course.title.toLowerCase().includes('project')
        );
        setCourses(filteredCourses);
        // setMessage(response?.data?.message);
      } catch (error) {
        setError('Error fetching courses. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  return (
    <div>
      {courses.length > 0 && (
        loading ? (
          <ClipLoader color="#333333" loading={loading} size={30} />
        ) : (
          <CourseTemplate coursesData={courses} pageTitle={t("Hands-On Project-Based Courses")} error={error} />
        )
      ) }
    </div>
  );
};

export default ProjectCourse;
